import {
  RosterContent,
  RosterEventRepository,
  RosterFeature,
  RosterResourceRepository,
  RosterService,
  RosterStructureRepository,
} from '@softapps/pms/roster';
import { getModuleGroupById } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { GarageRosterMenuBarComponent } from './menu-bar/menu-bar.component';
import { GarageRosterEventRepository } from './repositories/garage-roster-event.repository';
import { GarageRosterResourceRepository } from './repositories/garage-roster-resource.repository';
import { GarageRosterStructureRepository } from './repositories/garage-roster-structure.repository';
import { GarageRosterService } from './services/garage-roster.service';

export function withGarageRoster(): RosterFeature<RosterContent> {
  return {
    name: 'garage',
    module: {
      name: 'roster-garage',
      title: 'Werkst. Dienstplaner',
      icon: 'fa-regular fa-calendar-days',
      color: 'bg-accent text-white',
      permission: 'GARAGE.ROSTER',
      group: getModuleGroupById(11),
    },
    providers: [
      { provide: RosterService, useClass: GarageRosterService },
      { provide: RosterEventRepository, useClass: GarageRosterEventRepository },
      { provide: RosterResourceRepository, useClass: GarageRosterResourceRepository },
      { provide: RosterStructureRepository, useClass: GarageRosterStructureRepository },
    ],
    translations: { de },
    menuBar: GarageRosterMenuBarComponent,
    sidebarWidth: '380px',
    components: {
      eventComponent: () =>
        import('./components/garage-components/garage-event/garage-event.component').then(
          (o) => o.GarageEventComponent
        ),
      calendarResourceComponent: () =>
        import('./components/garage-components/garage-resource/garage-resource.component').then(
          (o) => o.GarageResourceComponent
        ),
      resourceComponent: () =>
        import('./components/garage-components/garage-tasks/garage-tasks.component').then(
          (o) => o.GarageTasksComponent
        ),
    },
  };
}
